// TeamsMenuWrapper.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import * as PathRouter from '../../../../../models/PathRoute';
import { lessonParticipantsApi } from "../../../../../utils";
import { throwApiError } from "../../../../lms-shared/store/error-handling-actions";
import { useDispatch, useSelector } from "react-redux";

const TeamsMenuWrapper = ({ homeUrl, children }) => {
  const [showTopicsData, setShowTopicsData] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const baseDispatch = useDispatch();
  const { texts } = useSelector(state => state.translate);

  useEffect(() => {

    const lessonParticipantAnyInput = {
      studyGroupId: id
    }
    lessonParticipantsApi.lessonParticipantsAnyPost({ lessonParticipantAnyInput }, (error, resdata, response) => {
      // setLoading(false);
      if (error) {
        baseDispatch(throwApiError({ userMessage: texts.errorLessonParticipantsAny, error: error, message: "lessonParticipantsAnyPost " + error.message, level: 2, component: "Teams", line: 121 }))
      }
      else {

        const teamBasicDivision = resdata; // Replace this with actual API interation

        if (!teamBasicDivision) {
                    setShowTopicsData(false);
          navigate(`${homeUrl}/${PathRouter.LEARNING_TRACKING}/${id}/${PathRouter.TEAMS}/all`,{ state: { showTeamsPopup: true } });
        } else {
          setShowTopicsData(true);
        }
      }
    })

  }, []);

  useEffect(() => {
    if (location.pathname.includes(PathRouter.TEAMS)) {
      if (location.pathname.includes('all')) {
        setShowTopicsData(false);
      } else {
        setShowTopicsData(true);
      }
    }
  }, [location.pathname]);

  return (
    <div>
      {showTopicsData && children}
    </div>
  );
};

export default TeamsMenuWrapper;
